import { defineMessages } from 'react-intl';

export default defineMessages({
  amountTitle: 'Available to withdraw',
  formDescription: 'How much do you want to withdraw?',

  pageTitle: `Withdraw {currencySymbol}`,

  connectWallet: 'Please connect a wallet',
  connectWalletDescription: 'We couldn’t detect a wallet. Connect a wallet to withdraw.',
});
